import React from 'react';
import logo from '../../assets/logo.png';

export default function Footer() {
  return (
    <footer className="w-full" style={{ background:'#0d0d0d' }}>
      <div className="footer-topline" />

      <div className="max-w-content mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-12 border-b border-white/[.06]">

          {/* Brand */}
          <div className="md:col-span-5">
            <img src={logo} alt="Chalk and Charter" className="h-11 w-auto object-contain mb-5" />
            <p className="text-white/40 text-sm leading-relaxed max-w-xs mb-8">
              Where brands connect with educational institutions.
              Authentic campus marketing that students trust.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/profile.php?id=61584959453443"
                target="_blank" rel="noopener noreferrer"
                className="px-4 py-2 rounded-lg text-white/40 hover:text-white text-xs font-bold transition-colors"
                style={{ background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.08)' }}>
                Facebook
              </a>
              <a href="https://www.linkedin.com/company/chalkandcharter/"
                target="_blank" rel="noopener noreferrer"
                className="px-4 py-2 rounded-lg text-white/40 hover:text-white text-xs font-bold transition-colors"
                style={{ background:'rgba(255,255,255,.05)', border:'1px solid rgba(255,255,255,.08)' }}>
                LinkedIn
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="text-white text-sm font-bold mb-6 uppercase tracking-widest">Services</h4>
            <ul className="space-y-3">
              {['BTL Marketing','Brand Partnerships','Campus Activations','Event Management'].map(s => (
                <li key={s} className="text-white/38 text-sm">{s}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="text-white text-sm font-bold mb-6 uppercase tracking-widest">Get in Touch</h4>
            <ul className="space-y-4 mb-8">
              {[
                { label:'Email',    val:'chalkandcharter@gmail.com', href:'mailto:chalkandcharter@gmail.com' },
                { label:'Phone',    val:'+977 9849943210',            href:'tel:+9779849943210'               },
                { label:'Location', val:'Tripureshwor, Kathmandu',    href: null                              },
              ].map(c => (
                <li key={c.label} className="flex items-start gap-3">
                  <span className="text-white/28 text-xs font-bold uppercase tracking-wider pt-0.5 w-16 shrink-0">{c.label}</span>
                  {c.href
                    ? <a href={c.href} className="text-white/50 text-sm hover:text-white transition-colors">{c.val}</a>
                    : <span className="text-white/50 text-sm">{c.val}</span>
                  }
                </li>
              ))}
            </ul>

            {/* Newsletter */}
            <p className="text-white/25 text-xs mb-3 font-semibold uppercase tracking-widest">Stay Updated</p>
            <div className="flex gap-2">
              <input type="email" placeholder="your@email.com"
                className="flex-1 bg-white/[.04] border border-white/[.09] rounded-lg px-4 py-2.5 text-white text-sm placeholder-white/20 focus:outline-none focus:border-red-500/40 transition-colors" />
              <button className="btn-red text-xs px-4 py-2.5 shrink-0">→</button>
            </div>
          </div>

        </div>

        {/* Bottom */}
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/22 text-xs">© 2026 Chalk and Charter. All rights reserved.</p>
          <div className="flex gap-6">
            {['Privacy','Terms','Cookies'].map(l => (
              <span key={l} className="text-white/22 text-xs">{l}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
